export default function FormModule(element) {
    let $generalError = element.querySelector('.form__generr');
    let $generalSuccess = element.querySelector('.form__gensuccess');
    
    element.addEventListener('submit',  function(event) {

        event.stopPropagation();
        event.preventDefault();

        clearFormErrors();

        setLoading(true);

        fetch(window.WP_ADMIN_URL + '/admin-ajax.php', {
            method: 'POST',
            body: new FormData(element)
        })
        .then(response => response.json())
        .then(function(res) {
            setLoading(false);

            if (res.errors) {
                displayErrors(res.errors);
            } else if (res.result !== 1) {
                showGeneralError(res.msg || window.TRANSLATIONS.GENERIC_ERROR);
            } else if (res.redirect) {
                location.href = res.redirect;
            } else {
                showThanks();
            }
        }).catch(function(err) {
            setLoading(false);
            console.error(err);
            showGeneralError(window.TRANSLATIONS.GENERIC_ERROR);
        })
    });

    function displayErrors(errors) {
        let firstError = null;
        for (let fieldName in errors) {
            let input = element.querySelector('*[name='+fieldName+']');
            let formGroup = input.closest('.form__group');
            let formError = formGroup.querySelector('.form__error');

            firstError = firstError || input;

            formGroup.classList.add('has-error');
            if (formError) {
                formError.style.display = 'block';
                formError.innerText = errors[fieldName];
            }
        }

        if (firstError) {
            firstError.scrollIntoView({
                behavior: 'auto',
                block: 'center',
            });
            firstError.focus();
        }
    }

    function showGeneralError(text) {
        $generalError.innerText = text;
        $generalError.style.display = 'block';
    }

    function setLoading(loading) {
        if (loading) {
            element.classList.add('is-loading');
        } else {
            element.classList.remove('is-loading');
        }
    }

    function showThanks() {
        if (!$generalSuccess) {
            return;
        }

        console.log($generalSuccess);

        $generalSuccess.style.display = 'block';
    }

    function clearFormErrors() {
        element.querySelectorAll('.has-error').forEach(el => el.classList.remove('has-error'));
        element.querySelectorAll('.form__error').forEach(el => el.style.display = 'none');
        $generalError.style.display = 'none';
    }

    return this;
}
